module.exports = __webpack_public_path__ + "static/priviliges-8-b64d0b152b6bfae0951c5cc86981f743.png";